import * as bi from 'react-bootstrap-icons';
import { Box, Button, Flex, Header } from 'components';
import { RoutingUrls } from 'common/const';
import './style.scss';

function NoneTickets() {
  return (
    <Box padding={20}>
      <Flex
        gap={20}
        direction='column'
      >
        <Header>У вас нет билетов!</Header>
        <span>Вы ещё не купили ни одного билета, но после покупки они будут доступны вам на этой странице.</span>
        <Flex
          alignItems='center'
          justifyContent='center'
          className='no-tickets-block-74mc8'
        >
          <bi.TicketPerforated />
        </Flex>
        <Button
          onClick={() => (window.location.href = RoutingUrls.Trips)}
          color='red'
        >
          <Flex
            gap={5}
            alignItems='center'
            justifyContent='center'
          >
            <bi.Luggage />
            <span>Поиск рейсов</span>
          </Flex>
        </Button>
      </Flex>
    </Box>
  );
}

export default NoneTickets;
